import { ApiAnalytics, ApiAnalyticsCustomizedBookedItem, ApiBooking } from '@ibe/api';

class AnalyticsBase {
  analytics?: ApiAnalytics | null;

  analyticsItem?: ApiAnalyticsCustomizedBookedItem | null;

  booking?: ApiBooking | null;
}

export default AnalyticsBase;
